<template>
  <el-dialog
    v-loading="loading"
    :title="title"
    :visible="true"
    width="600px"
    @close="$router.replace('/docket/docket-books')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="docketBook"
      :rules="rules"
      ref="docketBookForm"
      label-position="top"
      autocomplete="off"
      @submit.native.prevent="add"
    >

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="name"
            label="Név"
          >
            <el-input
              v-model="docketBook.name"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="own_company_id"
            label="Iroda"
          >
            <el-select
              v-model="docketBook.own_company"
              value-key="id"
              @change="docketBook.own_company_id = docketBook.own_company.id"
              style="width: 100%"
            >
              <el-option
                v-for="ownCompany in ownCompanies"
                :label="ownCompany.name"
                :value="ownCompany"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="prefix"
            label="Előtag"
          >
            <el-input
              v-model="docketBook.prefix"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="suffix"
            label="Utótag"
          >
            <el-input
              v-model="docketBook.suffix"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/docket/docket-books')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ['type', 'docketBookId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        docketBook: {},
        rules: {
          name: [
            { required: true, message: 'Név megadása kötelező', trigger: 'change' }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Iktatókönyv';
        } else if (this.type === 'update') {
          return 'Iktatókönyv módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
      ownCompanies() {
        return this.$store.getters['ownCompany/ownCompanies'];
      }
    },
    methods: {
      async add() {
        this.$refs['docketBookForm'].validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('docketBook/create', this.docketBook);
              } else if (this.type === 'update') {
                await this.$store.dispatch('docketBook/update', this.docketBook);
              }
              this.$store.dispatch('docketBook/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/docket/docket-books');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      }
    },
    async mounted() {
      this.loading = true;
      if(!this.ownCompanies.length) {
        await this.$store.dispatch('ownCompany/fetchAll');
      }
      if (this.docketBookId) {
        this.docketBook = await this.$store.dispatch('docketBook/fetch', this.docketBookId);
      } else {
        this.docketBook.own_company_id = this.ownCompanies[0].id;
        this.docketBook.own_company = this.ownCompanies[0];
      }
      this.loading = false;
    },
  };
</script>
